<template>

    <m-edit1/>

    <m-register-1 v-bind='{...{"image":null,"showPanels":false},...{}}' :style='""' class="" ></m-register-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mRegister1 from '@moeinmdn/miw-alpha-components/src/package/Authentication/Register/Register1/Register1';

export default {
    name: 'HomeView',
    components: {mEdit1, mRegister1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
